export var Api;
(function (Api) {
    Api["PREDICTIVE"] = "/api/predictive";
    Api["PRODUCTS"] = "/api/products";
    Api["SHOPPER_GAM"] = "/api/shopper-gam";
    Api["CAL_TELEMETRY"] = "/api/calvera-telemetry";
    Api["POL_TRACKING"] = "/api/trk";
})(Api || (Api = {}));
